import { Navigate } from 'react-router-dom';
import { useAuthStore, ROL } from '@/store/auth.store';

export function SuperAdminGuard({ children }: { children: React.ReactNode }) {
  const usuario = useAuthStore(s => s.usuario);
  if (usuario?.rolId !== ROL.SUPER_ADMIN) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
